'use client';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';
import { Box } from '@s7/base';
import { SimpleGrid, Group } from '@s7/layout';
import { rem } from '@s7/styles';
import { Image, Typography, Divider } from '@s7/ui';
import { useMediaQueryContext } from '../../../../../Footer.context.js';
import { AppItem } from '../../../slots/AppItem/AppItem.js';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const root = (theme)=>({
        display: 'flex',
        position: 'relative',
        alignItems: 'center',
        justifyContent: 'center',
        boxSizing: 'border-box',
        height: rem(220),
        borderRadius: theme.fn.borderRadius(),
        padding: rem('32 0'),
        backgroundColor: theme.palette.background.content
    });
const middleSide = (theme)=>({
        display: 'flex',
        flexDirection: 'column',
        position: 'absolute',
        gap: rem(16),
        [theme.fn.down('md1')]: {
            left: '37%'
        }
    });
const leftSide = (theme)=>({
        position: 'absolute',
        [theme.fn.up('md1')]: {
            left: rem(24)
        },
        left: rem(12),
        bottom: 0,
        width: rem(254),
        height: rem(196),
        objectFit: 'cover',
        objectPosition: 'left top'
    });
const rightSide = (theme)=>({
        right: 0,
        height: rem(98),
        width: '100%',
        marginRight: rem(28),
        [theme.fn.up('md1')]: {
            marginRight: rem(115)
        }
    });
const DesktopFullLayout = (props)=>{
    const { title, qrCode, image, items, locale, onItemClick, renderAppItem = AppItem } = props;
    const [isDesktop] = useMediaQueryContext();
    return /*#__PURE__*/ jsxs(Box, {
        sx: root,
        children: [
            image && /*#__PURE__*/ jsx(Image, {
                alt: image.title,
                fallback: false,
                height: "196",
                preview: image.preview,
                src: image.url,
                sx: leftSide,
                title: image.title,
                width: "254"
            }),
            (title || (items == null ? void 0 : items.length)) && /*#__PURE__*/ jsxs(Box, {
                sx: middleSide,
                children: [
                    title && /*#__PURE__*/ jsx(Typography, {
                        color: "text.mediumHigh",
                        size: "sm1",
                        variant: "heading",
                        children: title
                    }),
                    items && items.length && /*#__PURE__*/ jsx(SimpleGrid, _extends({
                        breakpoints: {
                            'md1.up': {
                                cols: 4,
                                spacing: 16
                            }
                        },
                        cols: 2,
                        spacing: 8
                    }, isDesktop && {
                        sx: {
                            marginBottom: rem(30)
                        }
                    }, {
                        children: items.map((_param)=>{
                            var { id } = _param, item = _object_without_properties_loose(_param, [
                                "id"
                            ]);
                            return renderAppItem(_extends({
                                key: id
                            }, item, {
                                locale,
                                compact: isDesktop,
                                onClick: (event)=>onItemClick == null ? void 0 : onItemClick(_extends({
                                        id
                                    }, item), event)
                            }));
                        })
                    }))
                ]
            }),
            qrCode && /*#__PURE__*/ jsxs(Group, {
                breakpoints: {
                    'md1.up': {
                        spacing: 60
                    }
                },
                position: "right",
                spacing: 42,
                sx: rightSide,
                children: [
                    /*#__PURE__*/ jsx(Divider, {
                        sx: (theme)=>({
                                [theme.fn.down(874)]: {
                                    display: 'none'
                                }
                            }),
                        color: "border.card",
                        orientation: "vertical"
                    }),
                    /*#__PURE__*/ jsx(Image, {
                        alt: qrCode.title,
                        fallback: false,
                        height: "98",
                        preview: qrCode.preview,
                        src: qrCode.url,
                        title: qrCode.title,
                        width: "98"
                    })
                ]
            })
        ]
    });
};

export { DesktopFullLayout };
//# sourceMappingURL=DesktopFullLayout.js.map
